var map = {
	"./camp.png": 1951,
	"./circle.svg": 1724,
	"./creative.png": 1952,
	"./frontend.png": 1953,
	"./gamedesign.png": 1954,
	"./graphicdesign.png": 1955,
	"./junior.png": 1956,
	"./math-3-4.png": 1957,
	"./math-5-6.png": 1958,
	"./pc.png": 1959,
	"./pytpro-nosnake.png": 1960,
	"./pytpro.png": 1961,
	"./pytstart-nosnake.png": 1962,
	"./pytstart.png": 1963,
	"./quadrangle.svg": 1722,
	"./unity.png": 1964,
	"./videocontent.png": 1965,
	"./websites.png": 1966
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1723;